import React, { Component, useState, useMemo, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { translate } from '../translations';
import { getTheme } from '../Theme';
import useWindowDimensions from '../hooks/useWindowDimensions';
import HamburgerMenu from 'react-hamburger-menu';

import { ReactComponent as HomeIcon } from '../icons/navbar/navbar_home.svg';
import { ReactComponent as AboutIcon } from '../icons/navbar/navbar_about.svg';
import { ReactComponent as ContactIcon } from '../icons/navbar/navbar_contact.svg';
import { ReactComponent as MediaIcon } from '../icons/navbar/navbar_media.svg';
// import { ReactComponent  as ResearchIcon }  from "../icons/navbar_research.svg";
import { ReactComponent as DownloadIcon } from '../icons/navbar/navbar_download.svg';
import { ReactComponent as OfferIcon } from '../icons/navbar/navbar_offer.svg';
import { ReactComponent as EngineIcon } from '../icons/navbar/navbar_engine.svg';
import { ReactComponent as ProjectIcon } from '../icons/navbar/navbar_project.svg';
import { ReactComponent as JobsIcon } from '../icons/navbar/navbar_jobs.svg';
import { ReactComponent as EyeIcon } from '../icons/navbar/navbarTop_eye.svg';

import logo from '../images/nd-logo-2.png';
import flagPL from '../images/flag-pl.png';
import flagEN from '../images/flag-en.png';

const tabs = [
  {
    name: 'Home',
    translation: 'Aktualności',
    color: '#00089a',
    icon: HomeIcon,
    style: 'left-corner'
  },
  {
    name: 'About',
    translation: 'O Firmie',
    color: 'yellow',
    icon: AboutIcon,
    style: ''
  },
  {
    name: 'Jobs',
    translation: 'Zapytania ofertowe',
    color: '#00089a',
    icon: JobsIcon,
    style: ''
  },
  {
    name: 'Engines',
    translation: 'Silniki LMB',
    color: 'purple',
    icon: EngineIcon,
    style: ''
  },
  // {name: 'Research', translation:'Badania', color:'#6be64a', icon: ResearchIcon, style:'' },
  {
    name: 'Project',
    translation: 'Projekt',
    color: '#00089a',
    icon: ProjectIcon,
    style: ''
  },
  {
    name: 'Offer',
    translation: 'Oferta',
    color: 'violet',
    icon: OfferIcon,
    style: ''
  },
  {
    name: 'Media',
    translation: 'Media o nas',
    color: 'red',
    icon: MediaIcon,
    style: ''
  },
  {
    name: 'Downloads',
    translation: 'Do pobrania',
    color: 'green',
    icon: DownloadIcon,
    style: ''
  },
  {
    name: 'Contact',
    translation: 'Kontakt',
    color: '#ff9110',
    icon: ContactIcon,
    style: 'right-corner'
  }
];

const changeLanguage = () => {
  const currentLang = localStorage.getItem('lang');

  if (currentLang === 'en') {
    localStorage.setItem('lang', 'pl');
  } else {
    localStorage.setItem('lang', 'en');
  }
  window.location.reload(false);
};

const changeTheme = () => {
  const currentTheme = localStorage.getItem('theme');

  if (currentTheme === 'wcag') {
    localStorage.setItem('theme', 'default');
  } else {
    localStorage.setItem('theme', 'wcag');
  }
  window.location.reload(false);
};

const changeFont = () => {
  const currentFont = localStorage.getItem('font');

  if (currentFont === 'big') {
    localStorage.setItem('font', 'default');
  } else {
    localStorage.setItem('font', 'big');
  }
  window.location.reload(false);
};

const Navigation = () => {
  const { width } = useWindowDimensions();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const closeHamburger = () => {
    return setIsMenuOpen(false);
  };

  const desktopNavigation = useMemo(() => {
    if (width >= 720) {
      return (
        <ul className="navigation-container">
          <div className={getTheme('navbar-tabs-container')}>
            {tabs.map((t, i) => (
              <NavbarTab tab={t} key={i} />
            ))}
          </div>
        </ul>
      );
    } else {
      return null;
    }
  }, [width]);

  const hamburgerMenu = useMemo(() => {
    if (width < 720) {
      return (
        <div className="hamburger-container">
          <HamburgerMenu
            isOpen={isMenuOpen}
            menuClicked={() => {
              setIsMenuOpen(!isMenuOpen);
            }}
            width={18}
            height={15}
            strokeWidth={3}
            rotate={0}
            color="#fff"
            borderRadius={2}
            animationDuration={0.5}
            className="hamburger-menu"
          />
          <div className={`menu ${isMenuOpen ? getTheme('is-open') : ''}`}>
          <div className="navbar-top">
            <div className="navigation-container">
              <div className="navigation-inner-left">
              <NavLink className='ue-home-href' exact to='/'>
                <img src="/static/media/nd-logo-2.22568ebc.png" class="navbar-logo" alt="logo"/>
              </NavLink>
               
                <h5>{translate('Witamy na stonie')}</h5>
                <h4> Filipek-Motors </h4>

              </div>

              <HamburgerMenu
                isOpen={isMenuOpen}
                menuClicked={() => {
                  setIsMenuOpen(!isMenuOpen);
                }}
                width={18}
                height={15}
                strokeWidth={3}
                rotate={0}
                color="#000b4e"
                borderRadius={2}
                animationDuration={0.5}
                className="hamburger-menu"
              />
            </div>
            </div>

            <ul>
              {tabs.map((t, i) => (
                <NavbarTab tab={t} key={i} onClick={closeHamburger} />
              ))}
            </ul>
            <div className='hamburger-navbar-bottom'>
                <div
                  className="navbar-top-icons"
                  title={
                    localStorage.getItem('lang') === 'en'
                      ? 'Tłumaczenie na język polski'
                      : 'Translate to english'
                  }
                  onClick={changeLanguage}
                >
                  <img
                    className="navigation-flag"
                    alt={'flag'}
                    src={
                      localStorage.getItem('lang') === 'en' ? flagPL : flagEN
                    }
                  />
                </div>
                <div className='navbar-top-icons'>
                <EyeIcon
                  onClick={changeTheme}
                  className={getTheme('icons') + ' ' + getTheme('navbar-hamburger-icon')}
                  title='Wersja dla niedowidzących'
                />
                </div>
              </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }, [width, isMenuOpen]);

  return (
    <nav>
      <div className='navbar-top'>
        <div className='navigation-container'>
          <div className='navigation-inner-left'>
          <NavLink className='ue-home-href' exact to='/'>
              <img src="/static/media/nd-logo-2.22568ebc.png" class="navbar-logo" alt="logo"/>
            </NavLink>
            <h5>{translate('Witamy na stonie')}</h5>
            <h4> Filipek-Motors </h4>
          </div>
          {width >= 720 && (
            <div className="navigation-inner-right">
              <div className="navbar-top-icons">
                <EyeIcon
                  onClick={changeTheme}
                  className={getTheme('icons')}
                  title="Wersja dla niedowidzących"
                />
              </div>

              <div
                className="navbar-top-icons"
                title={
                  localStorage.getItem('lang') === 'en'
                    ? 'Translate to english'
                    : 'Tłumaczenie na język polski'
                }
                onClick={changeLanguage}
              >
                <img
                  className="navigation-flag"
                  alt={'flag'}
                  src={localStorage.getItem('lang') === 'en' ? flagPL : flagEN}
                />
              </div>
            </div>
          )}
          {hamburgerMenu}
        </div>
      </div>
      {desktopNavigation}
    </nav>
  );
};

class NavbarTab extends Component {
  render() {
    const tab = this.props.tab;
    const prefixHref = '/';
    const SvgIcon = tab.icon;

    return (
      <li className={tab.style} onClick={this.props.onClick}>
        <NavLink
          to={prefixHref.concat(tab.name !== 'Home' ? tab.name : '')}
          activeClassName={getTheme('is-active')}
          exact
        >
          <SvgIcon className={getTheme('icons')} />
          <p className={getTheme('nav-link')}>{translate(tab.translation)} </p>
        </NavLink>
      </li>
    );
  }
}

export default Navigation;
